<template>
  <b-card no-body class="mb-2 mt-4  w-100 ">
    <b-card-header v-on:click="changeAngel = !changeAngel"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
      <div  v-b-toggle="getOrdem" variant="info" class="head-mes d-flex align-items-center">
        <div class="title-left pl-3">
          <div class="title-colapse-mirror">{{ title }}</div>
        </div>
        <div class="componente">
        <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
        <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
        </div>
      </div>
    </b-card-header>
    <b-collapse :id="getOrdem" :accordion="getOrdem" role="tabpanel">
      <div class="collapse-max">
        <b-card-body class="outroteste">
          <table class="table table-hover table-cus" v-bind:style="[ true ? 'border: 1px solid #dcdede;' : '' ]">
            <thead class="thead-third">
              <slot name="header"></slot>
              <tr>
                <th class="tamanhofixo"  v-if="dataParcela.numeroDeColuna >= 1"  style="backgroundColor: #30A75F" >
                  <span>{{dataParcela.primeiraColuna}}</span>
                </th>
                <th class="tamanhofixo"  v-if="dataParcela.numeroDeColuna >= 2"  style="backgroundColor: #30A75F" >
                  <span>{{dataParcela.segundaColuna}}</span>
                </th>
                <th class="tamanhofixo"  v-if="dataParcela.numeroDeColuna >= 3"  style="backgroundColor: #30A75F" >
                  <span>{{dataParcela.terceiraColuna}}</span>
                </th>
                <th class="tamanhofixo"  v-if="dataParcela.numeroDeColuna >= 4"  style="backgroundColor: #30A75F" >
                  <span>{{dataParcela.quartaColuna}}</span>
                </th>
                 <th class="tamanhofixo"  v-for="colTitle in columns" v-bind:key="colTitle" >
                  <span v-html="colTitle"></span>
                </th>
              </tr>
            </thead>
            <tbody v-if="dataTableCom.length > 0">
              <tr v-for="(datat, index) in dataTableCom" :key="index">
                <TableColumn v-if="dataParcela.numeroDeColuna == 1" :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.reEmpreendimentoUnidadePrecoo.valorUnicoFormatado" />
                <TableColumn v-if="dataParcela.numeroDeColuna >= 2" :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.reEmpreendimentoUnidadePrecoo.valorEntradaFormatado" />
                <TableColumn v-if="dataParcela.numeroDeColuna >= 4"  :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.reEmpreendimentoUnidadePrecoo.valorEntregaFormatado" />
                <TableColumn v-if="dataParcela.numeroDeColuna >= 3"  :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.reEmpreendimentoUnidadePrecoo.valorMensalFormatado" />
                <TableColumn v-if="dataParcela.numeroDeColuna >= 2"  :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.reEmpreendimentoUnidadePrecoo.valorBalao == 0 ? datat.reEmpreendimentoUnidadePrecoo.valorMensalFormatado :datat.reEmpreendimentoUnidadePrecoo.valorBalaoFormatado " />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.nomeApartamento" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.localidade" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.unidadeTipo.suites + ' Suítes'" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.posicao == 0 ? 'Sol da Manhã' : 'Sol da Tarde'" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.metro + ' M²'" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.valorMetroFormatado" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datat.valorTotalFormatado" />
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                  <td class="text-center" :colspan="title > 1 ? 11 :8">Sem dados</td>
              </tr>
            </tbody>
            <tfoot>
              <slot name="tfoot"></slot>
            </tfoot>
          </table>
        </b-card-body>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import Collapsemirrorsales from './collapsemirrorsales'
export default Collapsemirrorsales
</script>

<style scoped>
.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.teste {
  width:auto;
  height: 300px;
  overflow-x: scroll;
}

.tamanhofixo
{
  text-align: center;
  min-width: 300px;
}
.title-colapse-mirror{
    font-weight: bold;
    font-size: 20px;
}
.table-cus{
  width: 550%;
  overflow-y: scroll;
}
thead{
  width: 400px;
  overflow: auto;
}
.componente{
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}

.head-mes{
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}
.arrow-angel{
  font-size: 30px;
  color: black;
  padding-right: 20px;
  padding-bottom: 10px;
}
.collapse-max{
  overflow: auto;
  height: 40vh;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/collapsemirrorsales/collapsemirrorsales.vue